import CheckboxMultipleIcon from '@raison/static/icons/checkbox-multiple-line.svg';
import {InlineSvg, RsnButton, RsnDialog} from '@raison/ui-kit';
import React from 'react';
import {useNavigate, useSearchParams} from 'react-router';

export function ServiceUnavailableDialog() {
    const navigate = useNavigate();
    const navigateToHome = () => {
        navigate('/assets');
    };
    return (
        <RsnDialog.Window>
            <RsnDialog.CenteredHeader
                icon={{
                    element: <RsnDialog.StatusIcon status={'alert'} />,
                }}
            >
                Service unavailable
            </RsnDialog.CenteredHeader>
            <RsnDialog.Body>
                Something’s not working with the KYC service right now, but it’s temporary. Please try again later.
            </RsnDialog.Body>
            <RsnDialog.Footer column>
                <RsnButton.Primary onClick={navigateToHome}>Back to home</RsnButton.Primary>
                <RsnButton.Alike intent='secondary' as={RsnDialog.CloseTrigger}>
                    I got it
                </RsnButton.Alike>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}

export function StepAlreadyCompletedDialog({onContinue}: {onContinue: () => void}) {
    return (
        <RsnDialog.Window>
            <RsnDialog.CenteredHeader
                icon={{
                    element: (
                        <div className={'flex size-16 items-center justify-center rounded-full bg-neutral-20'}>
                            <InlineSvg src={CheckboxMultipleIcon} className={'size-10'} />
                        </div>
                    ),
                }}
            >
                You’ve already completed <span className={'text-nowrap'}>this step</span>
            </RsnDialog.CenteredHeader>
            <RsnDialog.Body>Just continue to the next one.</RsnDialog.Body>
            <RsnDialog.Footer column>
                <RsnButton.Primary onClick={onContinue}>Continue</RsnButton.Primary>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}

export type DialogName = 'service-unavailable' | 'step-already-completed';
export const useDialogs = () => {
    const navigate = useNavigate();
    const [params] = useSearchParams();

    const dialog = params.get('dialog') as DialogName;

    const setDialog = (dialog: DialogName) => {
        params.set('dialog', dialog);
        navigate({
            search: params.toString(),
        });
    };

    return [dialog, setDialog] as const;
};
